import React, { useEffect, useState } from "react";

// Package Import

import {
  Typography,
  Box,
  useTheme,
  Button,
  Grid,
  Paper,
  Chip,
  TextField,
  formControlClasses,
  outlinedInputClasses,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { useDecodedToken } from "../../Services/Routes/APP/PrivateRoute";
import { format } from "date-fns";

// User Import

import {
  GlobeBlueIcon,
  InventoryIcon,
  HashIcon,
  TempratureIcon,
  BatchIcon1,
  UnitsRequested,
  Injection,
} from "../../Svg";
import { headersPost } from "../../Services/API";
import { COMMON_API_URLS } from "../../Services/Routes/API";
import { commonRoutes, RoutesUrls } from "../../Services/Routes/APP";

// Component

const RequestDetails = ({ request }) => {
  // Hooks

	const user = useDecodedToken();
	const theme = useTheme();
	const navigate = useNavigate();

	// states
	const [open, setOpen] = useState(false);
	const [alertOpen, setAlertOpen] = useState(false);
	const [alertMsg, setAlertMsg] = useState("");
	const [alertIcon, setAlertIcon] = useState("error");
	const [statusTextAndColors, setStatusTextAndColors] = useState({
		text: "",
		textColor: "",
		backgroundColor: "",
	});
	// set status


  const getAppBasedUserRole = () => {
    switch (user?.role) {
      case "super_admin":
        return "admin";
      case "ministry":
        return "ministry";
      case "state":
        return "province";
      case "province":
        return "province";
      case "district":
        return "district";
      case "hospital":
        return "pou";
      case "pou":
        return "pou";
      default:
        return "";
    }
  };

	const requestType =
	  
    request?.sender_role === user?.role && request?.sender_id === user?.role_id
      ? "sent"
      : request?.receiver_role === user?.role &&
        request?.receiver_id === user?.role_id
      ? "received"
				: "";
	

	const acceptRequest = () => {
		navigate(
			`/${getAppBasedUserRole()}${commonRoutes?.batch?.issuedManually}`,
			{
				state: {
					request_data: request,
				},
			}
		);
	};

  const rejectRequest = () => {
    const data = {
      requests: {
        id: request?.id,
        status: "rejected",
      },
    };
    setOpen(true);

		headersPost(COMMON_API_URLS.UPDATE_REQUEST, data)
			.then((res) => {
				setOpen(false);
				if (res?.status === 200 && res?.data?.success) {
					navigate(-1);
				} else {
					setAlertOpen(true);
					setAlertMsg(res?.data?.message);
					setAlertIcon("warning");
				}
			})
			.catch((err) => {
				setOpen(false);
				const { response } = err;
				if (response?.status === 401) {
					localStorage.clear();
					navigate(RoutesUrls?.root);
				} else {
					setAlertOpen(true);
					setAlertMsg(response?.statusText);
					setAlertIcon("error");
				}
			});
	};


	const receiveInventory = () => {
		
		
		navigate(
			`/${getAppBasedUserRole()}${commonRoutes?.requests?.receiveInventory}`,
			{
				state: {
					request_data: request,
					type: requestType,
				},
			}
		);
	};

	const getStatusTextAndColors = () => {
		switch (request?.status) {
			case "pending":
				setStatusTextAndColors({
					...statusTextAndColors,
					text: "Pending",
					textColor: theme?.palette?.grey?.[700],
					backgroundColor: theme?.palette?.grey?.[100],
				});
				break;
			case "in_progress":
				setStatusTextAndColors({
					...statusTextAndColors,
					text: "In Progress",
					textColor: theme?.palette?.primary?.main,
					backgroundColor: theme?.palette?.grey?.[200],
				});
				break;
			case "approved":
				setStatusTextAndColors({
					...statusTextAndColors,
					text: "Approved",
					textColor: theme?.palette?.success?.main,
					backgroundColor: theme?.palette?.success?.light,
				});
				break;
			case "rejected":
				setStatusTextAndColors({
					...statusTextAndColors,
					text: "Rejected",
					textColor: theme?.palette?.error?.main,
					backgroundColor: theme?.palette?.error?.light,
				});
				break;
		}
	};

	useEffect(() => {
		getStatusTextAndColors();
	}, [request]);

	return (
		<Box display={"flex"} justifyContent={"center"} margin={"auto"}>
			{/* <Grid container spacing={2}> */}
			<Grid item spacing={2} xs={12} sm={12} md={5} lg={5} xl={5}>
				<Paper>
					<Box padding={2}>
						<Box
							display={"flex"}
							justifyContent={"space-between"}
							alignItems={"center"}
							mb={4}
						>
							<Box>
								<Typography variant="h6" component="div">
									Request Details 
								</Typography>
								{/* <Typography sx={{ mb: 1.5 }} color="text.secondary">
									updated 1 hour ago
								</Typography> */}
							</Box>
							<Box>
								<Chip
									sx={{
										minWidth: "70px",
										color: statusTextAndColors.textColor,
										backgroundColor: statusTextAndColors.backgroundColor,
										borderRadius: 1,
									}}
									label={statusTextAndColors.text}
								/>
							</Box>
						</Box>
						{/* 1 ROW */}
						<Grid
							container
							display={"flex"}
							justifyContent={"space-between"}
							alignItems={"center"}
							sx={{ mb: 1.5 }}
						>
							<Box display={"flex"} alignItems={"center"}>
								<Box
									height={"60px"}
									width={"60px"}
									display={"flex"}
									alignItems={"center"}
									justifyContent={"center"}
									sx={{
										backgroundColor: `${theme.palette.secondary.dark}`,
										borderRadius: 1.5,
									}}
								>
									<UnitsRequested />
								</Box>
								<Typography
									ml={2}
									sx={{
										textAlign: "left",
									}}
								>
									Units Requested
								</Typography>
							</Box>
							<Box sx={{ paddingTop: 1.2 }}>
								<Chip
									sx={{
										minWidth: "70px",
										color: "blue",
										borderRadius: 1,
									}}
									label={request?.quantity}
								/>
							</Box>
						</Grid>
						{/* 2nd Row */}
						<Grid
							container
							display={"flex"}
							justifyContent={"space-between"}
							alignItems={"center"}
							sx={{ mb: 1.5 }}
						>
							<Box display={"flex"} alignItems={"center"}>
								<Box
									height={"60px"}
									width={"60px"}
									display={"flex"}
									alignItems={"center"}
									justifyContent={"center"}
									sx={{
										backgroundColor: `${theme.palette.secondary.dark}`,
										borderRadius: 1.5,
									}}
								>
									<BatchIcon1 />
								</Box>
								<Typography ml={2}>Requested Date</Typography>
							</Box>
							<Box sx={{ paddingTop: 1.2 }}>
								<Chip
									sx={{
										minWidth: "70px",
										color: "blue",
										borderRadius: 1,
									}}
									label={
										request?.delivery_date
											? format(new Date(), "MM/dd/yyyy")
											: ""
									}
								/>
							</Box>
						</Grid>
						{/* 3rd Row */}
						<Grid
							container
							display={"flex"}
							justifyContent={"space-between"}
							alignItems={"center"}
							sx={{ mb: 1.5 }}
						>
							<Box display={"flex"} alignItems={"center"}>
								<Box
									height={"60px"}
									width={"60px"}
									display={"flex"}
									alignItems={"center"}
									justifyContent={"center"}
									sx={{
										backgroundColor: `${theme.palette.secondary.dark}`,
										borderRadius: 1.5,
									}}
								>
									<GlobeBlueIcon />
								</Box>
								<Box>
									<Typography variant="body1" component="div" ml={2}>
										{requestType === "sent"
											? "Requested To"
											: requestType === "received"
											? "Requested By"
											: ""}
									</Typography>
								</Box>
							</Box>
							<Box sx={{ paddingTop: 1.2 }}>
								<Chip
									sx={{
										minWidth: "70px",
										color: "blue",
										borderRadius: 1,
									}}
									label={
										requestType === "sent"
											? request?.receiver_name
											: requestType === "received"
											? request?.sender_name
											: ""
									}
								/>
							</Box>
						</Grid>
						{/* 4th Row */}
						<Grid
							container
							display={"flex"}
							justifyContent={"space-between"}
							alignItems={"center"}
							sx={{ mb: 1.5 }}
						>
							<Box display={"flex"} alignItems={"center"}>
								<Box
									height={"60px"}
									width={"60px"}
									display={"flex"}
									alignItems={"center"}
									justifyContent={"center"}
									sx={{
										backgroundColor: `${theme.palette.secondary.dark}`,
										borderRadius: 1.5,
									}}
								>
									<Injection />
								</Box>{" "}
								<Box>
									<Typography variant="body1" component="div" ml={2}>
										Request Type
									</Typography>
								</Box>
							</Box>
							<Box
								sx={{
									paddingTop: 1.2,
								}}
							>
								<Chip
									sx={{
										minWidth: "70px",
										color: "blue",
										borderRadius: 1,
									}}
									label={request?.sub_type}
								/>
							</Box>
						</Grid>
						<Grid container display={"flex"} sx={{ mb: 1.5 }}>
							<TextField
								variant="outlined"
								size={"small"}
								type={"text"}
								rows={2}
								name="note"
								disabled
								value={request?.note}
								multiline
								placeholder="Batch Reciever Description"
								fullWidth
								sx={{
									[`&.${formControlClasses?.root}`]: {
										border: "none",
									},
									[`& .${outlinedInputClasses?.root}`]: {
										backgroundColor: `${theme.palette.secondary.dark}`,
										borderRadius: theme.spacing(1),
									},
								}}
							/>
						</Grid>
						{requestType === "received" && request?.status == "pending" ? (
							<Box display={"flex"} justifyContent={"center"}>
								<Button
									variant="contained"
									size="large"
									onClick={acceptRequest}
									sx={{
										bgcolor: "#435CFF",
										borderRadius: 2,
										mr: 1,
									}}
								>
									Accept
								</Button>
								<Button
									variant="contained"
									size="large"
									onClick={rejectRequest}
									sx={{
										bgcolor: "#435CFF",
										borderRadius: 2,
										//   bgcolor: "success",
									}}
								>
									Reject
								</Button>
							</Box>
						) : null}
						{request?.status === "in_progress" && requestType === "sent" ? (
							<Box display={"flex"} justifyContent={"center"}>
								<Button
									variant="contained"
									size="large"
									onClick={receiveInventory}
									sx={{
										bgcolor: "#435CFF",
										borderRadius: 2,
										mr: 1,
									}}
								>
									Receive Inventory
								</Button>
							</Box>
						) : null}
					</Box>
				</Paper>
			</Grid>
			{/* </Grid> */}
		</Box>
	);
};

export default RequestDetails;
